// useSession — read-only access to SessionContext, narrow throw on misuse.

import { useContext } from 'react';
import type { SessionContextValue } from '../providers/SessionProvider.js';
import { SessionContext } from '../providers/SessionProvider.js';

export const useSession = (): SessionContextValue => {
  const ctx = useContext(SessionContext);
  if (ctx === null) {
    throw new Error('useSession must be called inside <SessionProvider>');
  }
  return ctx;
};
